<template>
    <div class="schedulesSearch">
        <Row :gutter="4">
            <Col span="4">
                <Input search v-model="schedulesSearchKey" :placeholder="$t('configuration_management.schedules.queryByName')" @on-search="searchSchedule()" />
            </Col>
            <Col span="16">
                <add-schedules></add-schedules>
            </Col>
        </Row>
    </div>
</template>
<script>
    import AddSchedules from '../schedules/AddSchedules'
    import TableSchedules from '../schedules/TableSchedules'
    var tableSchedules=TableSchedules;
    export default {
        name: 'SchedulesSearch',
        components: {
            AddSchedules
        },
        data () {
            return {
               schedulesSearchKey:'',
               scheduleSearchName:''
            }
        },
        methods:{
            searchSchedule(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('scheduleSearchName', this.schedulesSearchKey);
                tableSchedules.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .schedulesSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/schedules/SchedulesSearch.vue